
import { CustomerDto } from './customer.dto';
import { PWProductDto } from './pw-product.dto';

export class PwSacDto {
  customer: CustomerDto;
  businessUnit: string;
  roadId: number;
  brandId: number;
  model: string;
  year: number;
  km: number;
  frequentUseId: number;
  productQty: number;
  type?: 'SPECIAL' | 'NORMAL';
  customerAllegation: string;
  additionalInformation?: string;
  products: PWProductDto[];
}